(function () {
  'use strict';
  var overlay = document.getElementById('signupPopupOverlay');
  if (!overlay) return;
  var key = 'oikos_signup_popup_done';
  var timer;
  var previousFocus;
  var previousOverflow = '';
  function dismissed() {
    try { return localStorage.getItem(key) === '1'; } catch (error) { return false; }
  }
  function stopTriggers() { clearTimeout(timer); window.removeEventListener('scroll', onScroll); }
  window.closeSignupPopup = function () {
    stopTriggers();
    overlay.classList.remove('visible');
    overlay.hidden = true;
    document.documentElement.style.overflow = previousOverflow;
    try { localStorage.setItem(key, '1'); } catch (error) { /* storage is optional */ }
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  };
  function show() {
    if (dismissed() || !overlay.hidden) return;
    stopTriggers();
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    overlay.hidden = false;
    overlay.classList.add('visible');
    document.documentElement.style.overflow = 'hidden';
    overlay.querySelector('.signup-popup-close').focus();
  }
  function onScroll() { if (window.pageYOffset > 120) show(); }
  overlay.addEventListener('click', function (event) { if (event.target === overlay) window.closeSignupPopup(); });
  document.addEventListener('keydown', function (event) {
    if (overlay.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); window.closeSignupPopup(); }
    if (event.key !== 'Tab') return;
    var buttons = Array.from(overlay.querySelectorAll('a[href],button:not([disabled])'));
    var first = buttons[0], last = buttons[buttons.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  if (!dismissed() && !(window.Shopify && window.Shopify.designMode)) {
    timer = setTimeout(show, 9000);
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
